<script>
import EmployeeAPI from "@/services/employee/employeeAPI";
import CompanyAPI from "@/services/company/companyAPI";
import CompanySSOAPI from "@/services/sso/company/companySSO.API";
import ComiteAPI from "@/services/standards/committee/committeeLess10API";
import Table from "./components/Comite/Minor10/ComiteTable";
import ItemAPI from "@/services/items/itemsAPI";
import Swal from "sweetalert2";
import CheckModal from "@/components/CheckModal";
import uploadDocument from "@/utils/digitalOcean/digitalocean-upload-file";
import { dateFormat } from "@/utils/helpers/format";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import { sendNotification } from "@/utils/helpers/notification";
import newScoresAPI from "../../../services/newScores/newScoresAPI";

export default {
  props: {
    companyID: {
      type: Number,
      default: 0,
    },
  },
  components: {
    CheckModal,
    Table,
  },
  data() {
    return {
      checked: true,
      checked2: false,
      status: "accepted",
      status2: "not_accepted",
      selected: "A",
      employees: [],
      company: null,
      employee: { id: null },
      copassDate: null,
      file: null,
      copassFile: "This is a file link",
      rows: [],
      item: null,
      itemData: null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
      loading1: true,
      dateFrom: null,
      dateTo: null,
      itemStatus: "No cumplido",
      lastId: 1,
      submitted: false,
    };
  },
  methods: {
    getItemData() {
      ItemAPI.getItems(8)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    /**
     * This method indicates whether the company has a classification corresponding to
     * the permit for the item in question.
     * @param {JSON} item The item object.
     */

    allowAccess() {
      try {
        const item = this.itemData;

        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"].company_classification_id || null;

          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    /**
     * This method is used to send notification to SST user and SST company.
     * The sendNotification method import is required.
     * @param {Number} messageID - The message ID that will be associated to notification.
     * @param {Number} itemID - The item ID that will be associated to notification.
     * @param {Boolean} user - The user that will e associated to notification.
     * @return {Boolean} True if the notification is sent, false if not.
     */
    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(company.id, user ? company.id_diseno_sso : null, messageID, itemID);
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 8)
        .then((response) => {
          try {
            this.item = response || null;
            this.itemStatus = response.status;
          } catch (error) {
            console.log(error);
            this.item = null;
            this.itemStatus = null;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    changeItemStatus(itemStatus) {
      const itemChange = {
        companies_id: this.companyID,
        item_id: 8,
        status: itemStatus,
      };
      newScoresAPI.calculateScores(itemChange)
        .then((response) => {
          Swal.fire({
            title: "¡Éxito!",
            text: "¡Se ha actualizado el estado del ítem con éxito!",
            type: "success",
            icon: "success",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },

    /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;

      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty

        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role = role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;

        // Know if the user has the permission indicated
        const enabled = permissions.find((permission) => permission.name === name);

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged

      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },

    /**
     * This method is used to redirect to the page indicated
     * @param {String} page The page to redirect
     */
    goPage(page) {
      window.location.href = page;
    },

    async uploadFile() {
      this.file = this.$refs.file.files[0];
    },

    async uploadDocument() {
      try {
        let url = "";
        if (process.env.VUE_APP_ENV === 'development') {
          url = `sst-dev/${this.nit}/1.1.8/Acta-Commite-Convivencia/${this.lastId}/${this.file.name}`;
        } else {
          url = `sst-prod/${this.nit}/1.1.8/Acta-Commite-Convivencia/${this.lastId}/${this.file.name}`;
        }
        const result = await uploadDocument(url, this.file);
        if (result) {
          this.file = `${process.env.VUE_APP_BUCKET}/${url}`;
          return true;
        } else return false;
      } catch (error) {
        console.log(error);
      }
    },

    dateConvert(date) {
      return dateFormat(date);
    },

    getEmployees() {
      CompanyAPI.getCompany(this.companyID).then((res) => {
        CompanySSOAPI.getCompany(res.uuid)
          .then((r) => {
            this.company = r.nit;
            EmployeeAPI.getAllEmployees()
              .then((response) => {
                let allEmployees = response.employees || [];
                if (allEmployees.length > 0) {
                  let employees = allEmployees.filter((employee) => {
                    return (
                      employee.companies_id == this.companyID &&
                      (employee.contract_type_id === 1 || employee.contract_type_id === 3)
                    );
                  });
                  this.employees = employees;
                  this.loading1 = false;
                }
              })
              .catch((error) => {
                console.log(error);
              });
          })
          .catch((error) => {
            console.log(error);
          });
      });
    },

    async save() {
      try {
        this.submitted = true;
        this.loading1 = true
        let response = await this.uploadDocument();
        if (response) {
          ComiteAPI.save({
            date: this.copassDate,
            archive: this.file,
            position: "Representante del Comité de Convivencia Laboral",
            employee_id: this.employee,
          }).then((response) => {
            this.sendNotification(21, 8, true);
            setTimeout(() => {
              Swal.fire({
                title: "¡Éxito!",
                text: "¡Se ha registrado con éxito!",
                icon: "success",
                type: "success",
                confirmButtonClass: "btn btn-confirm mt-2",
              });
              window.location.reload();
            }, 1500);
          })
            .catch((error) => {
              console.log(error);
            });
        } else {
          this.loading1 = false
          setTimeout(() => {
            Swal.fire({
              title: "¡error!",
              text: "¡No se ha podido cargar el documento!",
              icon: "error",
              type: "error",
              confirmButtonClass: "btn btn-confirm mt-2",
            });
          }, 1500)
        }
      } catch (error) {
        console.log(error);
      }
    },

    getCommittee() {
      ComiteAPI.getCommittee(this.companyID)
        .then((response) => {
          const committee = response.cc_minus_ten.data || [];
          if (committee.length > 0) {
            let list = committee.filter((item) => {
              return item.cc_minus_ten !== null;
            });
            this.rows = list || [];
          }
          if (response.cc_minus_ten.data['id']) {
            this.lastId = response.cc_minus_ten.data['id'] + 1
          }
          this.loading1 = false;
        })
        .catch((error) => {
          console.log("This is an error on getCommittee", error);
        });
    },

    print() {
      const pdf = ComiteAPI.printCommittee(this.employee);
      window.location.href = pdf;
    },
  },
  mounted() {
    this.getEmployees();
    this.getCommittee();
    this.getItems();
    this.getItemData();
  },
};
</script>

<template>
  <div class="card-body">
    <div v-if="!loading1">
      <div class="row">
        <div class="col-md-6 col-sm-12">
          <CheckModal>
            <p class="text-justify">
              La empresa cuenta, de acuerdo con el número de trabajadores con:
            </p>
            <p class="text-justify">
              <b>Representante del comité de Convivencia Laboral</b> para empresas de
              menos de diez (10) de trabajadores.
            </p>
            <p class="text-justify">
              <b>Comité de Convivencia Laboral</b>, para empresas de diez (10) o más
              trabajadores.
            </p>
          </CheckModal>
        </div>

        <div class="form-row col-md-6 col-sm-12 pt-1">
          <b-form-group id="changeStatus" label-for="changeStatus" class="col-sm-12" label="Estado del ítem">
            <b-form-select v-on:change="changeItemStatus(itemStatus)" :disabled="!allowAccess() || !getRole('Actualizar items', [1, 2, 3]) || !item
              " plain class="selectpicker form-control" v-model="itemStatus">
              <b-form-select-option value="Aprobado"> Aprobado </b-form-select-option>
              <b-form-select-option value="Pendiente"> Pendiente </b-form-select-option>
              <b-form-select-option value="No cumplido">No cumplido</b-form-select-option>
            </b-form-select>
          </b-form-group>
        </div>
      </div>
      <h5 class="pt-2">Designado del Empleador</h5>

      <form class="form-group" @submit.prevent="save">
        <div class="form-row pt-3">
          <b-form-group class="col-md-4 px-2" label="Fecha" label-for="employee">
            <b-form-input :disabled="!allowAccess() || !getRole('Crear')" required type="date" id="employee"
              v-model="copassDate" placeholder=""></b-form-input>
          </b-form-group>

          <b-form-group class="col-md-4 px-2" label="Nombre" label-for="employerDate">
            <b-form-select :disabled="!allowAccess() || !getRole('Crear')" required class="form-control"
              v-model="employee">
              <b-form-select-option v-for="item in employees" :key="item.id" :value="item.id">
                {{ item.full_name }}
              </b-form-select-option>
            </b-form-select>
          </b-form-group>

          <b-form-group class="col-md-4 px-2" label="Acta de Comité de Convivencia firmada" label-for="committeeAct">
            <b-form-file :disabled="!allowAccess() || !getRole('Crear')" required type="file" id="file" ref="file"
              name="file" browse-text="Buscar" :placeholder="`Selecciona un archivo...`"
              drop-placeholder="Suelta acá..." v-model="file" @change="uploadFile" v-on:change="uploadFile"
              accept=".doc,.pdf, .xlsx, .xls, .docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document">
            </b-form-file>
          </b-form-group>
        </div>

        <div class="form-group text-right mr-2">
          <button type="button" :disabled="!allowAccess() || copassDate === null || employee === null" @click="print"
            class="btn btn-outline-primary" id="tooltip">
            <i class="bx bxs-printer"></i>
          </button>
          <b-tooltip target="tooltip" placement="left">
            Imprimir formato de acta
          </b-tooltip>

          <button :disabled="submitted" type="submit" class="btn btn-primary mx-1 ml-2">
            Guardar
          </button>

          <button type="reset" class="btn btn-secondary mx-1" @click="employee = null">
            Cancelar
          </button>
        </div>

        <hr />

        <div class="row">
          <div class="col-lg-12">
            <div>
              <div class="card-body">
                <Table />
              </div>
            </div>
            <!-- end card -->
          </div>
          <!-- end col -->
        </div>
      </form>
    </div>

    <div v-else>
      <div class="text-center">
        <b-spinner variant="primary" label="Loading..."></b-spinner>
      </div>
    </div>
  </div>
</template>
